import { useState } from 'react';
import PropTypes from 'prop-types';
import TwoFactorChallenge from './TwoFactorChallenge.jsx';
import TwoFactorVerification from './TwoFactorVerification.jsx';

/**
 * TwoFactorFlow Component (v2 themed)
 * Mirrors legacy implementation but uses themed subcomponents
 */
export default function TwoFactorFlow
({
    email,
    challengeToken,
    onSuccess,
    onCancel,
    initialChallengeData = null
})
{
    const [currentStep, setCurrentStep] = useState(initialChallengeData ? 'verify' : 'challenge');
    const [challengeData, setChallengeData] = useState(initialChallengeData);

    const handleChallengeRequested = (data) =>
    {
        setChallengeData(data);
        setCurrentStep('verify');
    };

    const handleVerificationSuccess = (data) =>
    {
        if(onSuccess)
        {
            onSuccess(data);
        }
    };

    const handleCancel = () =>
    {
        setCurrentStep('challenge');
        setChallengeData(null);
        if(onCancel)
        {
            onCancel();
        }
    };

    switch(currentStep)
    {
        case 'challenge':
        {
            return (
                <TwoFactorChallenge
                    email={email}
                    challengeToken={challengeToken}
                    onChallengeRequested={handleChallengeRequested}
                    onCancel={handleCancel}
                />
            );
        }
        case 'verify':
        {
            return (
                <TwoFactorVerification
                    email={email}
                    challengeData={challengeData}
                    challengeToken={challengeToken}
                    onVerificationSuccess={handleVerificationSuccess}
                    onCancel={handleCancel}
                />
            );
        }
        default:
        {
            return null;
        }
    }
}

TwoFactorFlow.propTypes = {
    email: PropTypes.string.isRequired,
    challengeToken: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
    onCancel: PropTypes.func,
    initialChallengeData: PropTypes.object
};
